import { ChatIcon } from "vega-icons";

import { NavigationCard } from "@vega-core/components/Cards/NavigationCard/NavigationCard";
import { FAQList } from "@vega-core/components/FAQ/FAQList";
import { ModalHeader } from "@vega-core/components/Modals/ModalHeader/ModalHeader";
import { VegaDialog } from "@vega-core/components/Modals/VegaDialog/VegaDialog";
import { type FAQItemType } from "@vega-core/models/faq.type";
import { m } from "@vega-core/paraglide/messages";

type Props = {
  open: boolean;
  onClose: VoidFunction;
  onOpenContactUs: VoidFunction;
  faqItems?: FAQItemType[];
};

export const HelpModal = ({
  open,
  onClose,
  faqItems,
  onOpenContactUs,
}: Props) => {
  const handleOpenContactUs = () => {
    onClose();
    onOpenContactUs();
  };

  return (
    <VegaDialog data-testid="help-dialog" onClose={onClose} open={open}>
      <div className="flex flex-col gap-4">
        <ModalHeader title={m.btn_needHelp()} />

        <div className="flex flex-col mt-8 gap-y-8">
          <FAQList data={faqItems} withBorders />
          <NavigationCard
            description={m.help_contactUsDescription()}
            icon={<ChatIcon className="w-7 h-7 text-text/interactive" />}
            onClick={handleOpenContactUs}
            title={m.titles_contactUs()}
            variant="iconBg"
          />
        </div>
      </div>
    </VegaDialog>
  );
};
